import { VersionCheckService } from '@bn/shared/services';

export function initApp(_versionCheckService: VersionCheckService) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return (): void => {};
}
